import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="7mm"
    height={19.733}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 149070 111183"
    {...props}
  >
    <path
      d="M8373 2130h132324c3435 0 6244 2811 6244 6243v79302c0 3435-2809 6244-6244 6244H78905v9240h33739v5894H36426v-5894h33737v-9240H8373c-3432 0-6243-2809-6243-6244V8373c0-3432 2811-6243 6243-6243zm70532 86537c0-2413-1957-4372-4372-4372s-4372 1959-4372 4372c0 2415 1957 4372 4372 4372s4372-1957 4372-4372zM13563 13744h121944v69054H13563V13744z"
      style={{
        // fill: "#2b2a29",
        // stroke: "#2b2a29",
        strokeWidth: 4259.15,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
